import $ from 'jquery';

export const shareInfo = {
  title: '凡人修仙傳M | 事前登錄活動頁 超多福利等你來拿！',
  descript: '凡人修仙傳M：正版IP授權自由修仙手遊，超多預約福利等你來拿！',
};

export const commentList = [
  '哈哈哈我築基時比韓立還年輕',
  '還能被掃帚給絆倒摔死。。。',
  '沒有靈根還能繼續修仙嗎？......無語子',
  '我父親是魔教聖子，哈哈哈哈我喜歡！',
  '我父親是宗門掌門，哈哈哈開心~',
  '為什麼只有我的父親是個凡人，嗚嗚嗚。',
  '你們就好啦，我還沒有父親QAQ',
  '我是千里眼誒~',
  '我英雄救美了哈哈哈，這個妹子會是道侶嗎？',
  '長老給了一塊碧玉，這個是金手指嗎？',
  '這麼快就喜結連理了。。。',
  '暈哦，是幹活的好苗子所以被收入門下，所以是去打雜嗎？',
  '哈哈哈神算子，你們有問題都來問我！',
  '無人願意成為我的師尊，嗚嗚嗚。',
  '哈哈哈哈小師妹是我的啦~~',
  '跟師妹雙宿雙飛咯~~~大道長生，不如凡人精彩一生！',
  '師妹還會痛經6666',
  '師傅被大師兄綠了吧笑死！',
  '我被下毒了，氣死！',
  '我築基成功啦~~~~',
  '我坐化了，啊這？啊這？啊這？',
  '我奪寶死了。。。',
  '我是個什麽丐幫命。。。',
  '被師父奪舍惹',
  '出生就流落街頭，開始擺爛',
  '13嵗就碰到道侶在雙休？？',
  '有沒有師妹一起雙修呀~',
  '開局就摔下桌子。。很機車欸',
  '師妹好還是師姐好呢...',
  '出生就是小開，運氣不差',
  '我不要修仙我要認真唸書',
  '修仙之路長漫漫，我與孤寂長作伴',
  '重開了好多回，命運總是如此的相似，正如修仙之路總是不易，早折才是常理',
  '滿足了我修仙的幻想，也造就了我對修仙的失望，命運多舛從來不是一句空話，一步登天也從來不是什麽實際',
  '小老兒修道至今已一萬兩千七百載，至今還停留在筑基境界不得寸進，貧道知道自己陽壽無多，血脈枯竭仙途無望，如今只想尋一水靈根妙人兒雙修以解萬年單身之苦。',
  '只要熬死諸位道友，貧道也能做一做那頂上仙人',
  '這是我玩這個小遊戲的第一千兩百四十三年零六個月又四十三天，我在輪迴中一次次重開，至今未能達成圓滿結局，不知諸位道友可有成功的否？',
  '修真一途，本就逆天而行，不進則退！36867年，吾九死一生，終於突破元嬰，破曉而出。',
  '修不修仙的也不重要了，能和師姐師妹談情說愛，花天酒地才是吾之所求！',
  '嗚呼！吾命休矣！修仙！修仙！ 沒想到到死還是單身！！',
  '吾與師妹情投意合，但卻發現她將為他人之妻，吾甚喜，痛飲幾大杯，仰天長嘯出門去。',
  '各位道友修為通天徹地，不知與我這修道一萬又兩千余載的散仙相比又如何',
  '本座修道兩萬三千年，一路坎坷，終成金仙。',
  '天仙默默看著你',
  '本座已看破紅塵兩千余載，於此遊戲下與諸位道友論道',
  '此天是我開，此地是我辟，要想修此仙，留下買路財',
  '樓上的是個人才',
  '可以多加點雙修的劇情嗎，哈哈哈',
  '我境界低，不知道后面的劇情是怎樣的',
  '又一個走火入魔的，埋了吧',
  '在座的諸位都是人才，我說這話應該沒人反對吧',
  '這個出個正式版遊戲感覺也很有意思哦',
  '還行吧，玩起來挺好玩的',
  '這個隨機的結果挺多的，每次出來的結局都不一樣，只是基本都好慘',
  '真的非常有意思，裏面內容非常豐富',
  '祝大家早日飛升，縱橫仙界',
  '很好玩很有意思',
  '時間會證明一切',
  '修仙一時快樂，一直修仙一直快樂。',
  '奪寶過程中身消道殞可也太現實了吧',
  '让我体验了一次修仙的感觉',
  '我出生了，我又死了',
  '有修仙成功了的朋友嗎？',
  '本道修真12000余載，年少時，闖蕩江湖數百年，終成築基大道',
  '吾不死，修真不止',
  '很有代入感',
  '您當年放棄進軍文壇我是第一個不同意的。',
  '挺有意思的，給了我挺多思考和聯想的。',
  '想把所有結局都打出來',
  '重開很多次了',
  '渡劫成功!你飛升到仙界了。',
  '我作為「人」的人生結束了，以後是修仙者了',
  '我不做人啦，jojo',
  '劇情有趣味性，能讓玩家快速體驗了修仙人生百態',
  '突然的死亡帶來的意外',
  '能玩得到修仙結局嗎？',
  '廢柴模擬器',
  '很好玩的一款遊戲，主要是有一種不可預知性',
  '天天想著修仙',
  '有些情況挺有意思，雖然重復的挺多。',
  '超好玩！',
  '剛剛被師姐搭訕超爽(*^▽^*)',
  '很好奇可不可以雙修XD',
  '我只是想築基而已。。。',
  '又來一枚升仙令',
  '有無人知遊戲幾時會上線',
  '才知道原來分享有獎勵~',
  '你們都到什麼境界',
  '被騙到只剩一套衣服是何狀況',
  '讚喔',
  '好玩~支持~',
  '終於渡劫成功吼爽爽爽！',
  '被殺掉……哭啊',
  '這個好玩欸~',
  '終於飛升了！！！',
  '請問這裡是天南嗎',
  'GG',
  '又沒有築基T_T  森77',
  '喔~~喔喔~~喔喔~~',
  '想要小綠瓶',
  '重開一次就有獎勵欸！',
  '達成成就：平平無奇。。。',
];

export const TIPS = {
  login: '請先登入',
  common: '操作失敗',
  shareFail: '分享失敗',
  shareSuc: '分享成功',
  getShareSucc: '獲取分享次數成功',
  pleaseServer: '請選擇伺服器',
  pleaseRole: '請選擇角色',
  getAwardSucc: '領取獎勵成功',
  bindSucc: '綁定成功',
  gotAward: '已經領取過獎勵',
  cannotAward: '未達到領獎條件',
  logoutFail: '登出失敗',
  shareAwardFail: '領取失敗',
  lotteryError: '抽獎次數不足',
  phoneNeed: '請先輸入電話號碼',
  checkNeed: '請先勾選服務條款',
  reserveNeed: '請道友先進行預約哦~',
  gameNeed: '您還沒有完成修仙之旅，請完成歷練后再進行分享喲~',
};

export const alert = (key, text) => {
  let txt = text || TIPS[key] || TIPS.common;
  $('.j-tips-popup .j-tips').html(txt);
  $('.j-tips-popup').fadeIn(500);
};

export const showReserveTips = text => {
  $('.j-reserve-popup .j-tips').html(text).fadeIn(100);
};

export const getRandomAvatar = () =>
  'avatar-' + (Math.round(Math.random() * 14) || 1);

export const initComment = () => {
  /*渲染抽奖名单轮播数据*/
  let randomMsgArray = commentList.sort(function () {
    return 0.5 - Math.random();
  });
  let html = ``;
  for (let v of randomMsgArray) {
    // html += `<p class="chat-item">${v}</p>`;
    html += `<div class="chat-item"><i class="avatar ${getRandomAvatar()}"></i><p class="chat-text">${v}</p></div>`;
  }
  $('.j-chat-wrap,.j-mini-chat-wrap').html(html);
};
